import { VIDEO_SKIP_SECONDS } from "constants/streaming";
import Player from "video.js/dist/types/player";

import { getVideoJsComponent } from "./utils";

import type { THEOPlayerRuntime } from "./theoplayerRuntime";

export const getMobileController = (runtime: THEOPlayerRuntime) => {
  const VideoJSComponent = getVideoJsComponent("Component", runtime);

  class MobileController extends VideoJSComponent {
    constructor(player: Player, options = {}) {
      super(player, options);
    }

    createEl() {
      const el = super.createEl("div", {
        className: "vjs-custom-mobile-controller",
      });
      return el;
    }
  }

  return MobileController;
};

export const getMobileControllerPlayButton = (runtime: THEOPlayerRuntime) => {
  const VideoJSButton = getVideoJsComponent("Button", runtime);

  class MobileControllerPlayButton extends VideoJSButton {
    handleUpdate: () => void;

    constructor(player: Player, options = {}) {
      super(player, options);
      this.handleUpdate = () => this.updateIcon();

      this.handleUpdate();

      player.on(["play", "pause"], this.handleUpdate);
    }

    dispose() {
      this.player().off(["play", "pause"], this.handleUpdate);
      super.dispose();
    }

    handleClick() {
      if (this.player().paused()) {
        void this.player().play();
      } else {
        this.player().pause();
      }
    }

    updateIcon() {
      const isPlaying = !this.player().paused();
      this.el().innerHTML = isPlaying
        ? `
        <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 21.5067H6.0067V0.493305H0V21.5067ZM11.9933 0.493305V21.5067H18V0.493305H11.9933Z" fill="white"/>
        </svg>
      `
        : `
        <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M-0.00683594 0.49332V21.5067L16.5066 11L-0.00683594 0.49332Z" fill="white"/>
        </svg>
      `;
    }

    createEl() {
      const el = super.createEl("div", {
        className:
          "vjs-custom-mobile-controller-button vjs-custom-mobile-controller-play",
      });
      return el;
    }
  }

  return MobileControllerPlayButton;
};

export const getMobileControllerRewindButton = (runtime: THEOPlayerRuntime) => {
  const VideoJSButton = getVideoJsComponent("Button", runtime);

  class MobileControllerRewindButton extends VideoJSButton {
    constructor(player: Player, options = {}) {
      super(player, options);
    }

    handleClick() {
      const currentTime = this.player().currentTime();
      if (currentTime !== undefined)
        this.player().currentTime(currentTime - VIDEO_SKIP_SECONDS);
    }

    createEl() {
      const backwardIcon = `
      <svg width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9865 6.16667V0.833336L4.31982 7.5L10.9865 14.1667V8.83334C15.3998 8.83334 18.9865 12.42 18.9865 16.8333C18.9865 21.2467 15.3998 24.8333 10.9865 24.8333C6.57316 24.8333 2.98649 21.2467 2.98649 16.8333H0.319824C0.319824 22.7267 5.09316 27.5 10.9865 27.5C16.8798 27.5 21.6532 22.7267 21.6532 16.8333C21.6532 10.94 16.8798 6.16667 10.9865 6.16667Z" fill="white"/>
      </svg>
    `;

      const el = super.createEl("button", {
        className:
          "vjs-custom-mobile-controller-button vjs-custom-mobile-controller-rewind",
        innerHTML: `
        ${backwardIcon}
        <span class="vjs-control-text">Back 10 seconds</span>
      `,
        title: "Back 10 seconds",
      });
      return el;
    }
  }

  return MobileControllerRewindButton;
};

export const getMobileControllerForwardButton = (
  runtime: THEOPlayerRuntime
) => {
  const VideoJSButton = getVideoJsComponent("Button", runtime);

  class MobileControllerForwardButton extends VideoJSButton {
    constructor(player: Player, options = {}) {
      super(player, options);
    }
    handleClick() {
      const currentTime = this.player().currentTime();
      if (currentTime !== undefined) {
        this.player().currentTime(currentTime + VIDEO_SKIP_SECONDS);
      }
    }

    createEl() {
      const forwardIcon = `
      <svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 18C21 22.965 16.965 27 12 27C7.035 27 3 22.965 3 18C3 13.035 7.035 9 12 9V15L19.5 7.5L12 0V6C5.37 6 0 11.37 0 18C0 24.63 5.37 30 12 30C18.63 30 24 24.63 24 18H21Z" fill="white"/>
      </svg>
    `;

      const el = super.createEl("button", {
        className:
          "vjs-custom-mobile-controller-button vjs-custom-mobile-controller-forward",
        innerHTML: `
        ${forwardIcon}
        <span class="vjs-control-text">Forward 10 seconds</span>
      `,
        title: "Forward 10 seconds",
      });
      return el;
    }
  }

  return MobileControllerForwardButton;
};
